import React from 'react';

export default function ImageThumb({id, filename, title, base64, onRemove})
{
    return (
        <div>
            <button className='button button-small' title="Remove this image" onClick={evt =>
            {
                evt.stopPropagation();
                evt.preventDefault();
                onRemove(evt, id);
            }}><i className='icon-cross'></i></button>            
            <img alt={title} src={base64} />
            <code>![{title}]({filename})</code>
        </div>
    );
};